import { UserConsent } from "cookiesConsent/domain/consent"
import { SegmentCategoriesFactory } from "cookiesConsent/infrastructure/segment/SegmentCategories"
import { consentBus } from "cookiesConsent/infrastructure/segment/ConsentBus"
import { startDeferredSegment } from "cookiesConsent/infrastructure/segment/startDeferredSegment"
import { latestConsent } from "cookiesConsent/features/getConsent/latestConsent"

export class AnalyticsActivation {
  private startedWith: UserConsent | null = null

  start = (consent: UserConsent): void => {
    if (this.startedWith) {
      this.ignore()
    } else {
      this.startedWith = consent
      latestConsent.publish(consent)
      consentBus.publish(new SegmentCategoriesFactory().fromConsent(consent))
      startDeferredSegment()
    }
  }

  reset = (): void => {
    this.startedWith = null
  }

  requiresRestart = (consent: UserConsent): boolean => {
    if (!this.startedWith) {
      return false
    } else {
      return !new SegmentCategoriesFactory()
        .fromConsent(this.startedWith)
        .equals(new SegmentCategoriesFactory().fromConsent(consent))
    }
  }

  private ignore = (): void => {}
}

export const analyticsActivation = new AnalyticsActivation()
